export const GET_FEEDS = "GET_FEEDS";
export const GET_FEEDS_BY_OPERATOR = "GET_FEEDS_BY_OPERATOR";
export const GET_FEEDS_BY_MANAGER = "GET_FEEDS_BY_MANAGER";
export const GET_FEEDS_BY_ADMIN = "GET_FEEDS_BY_ADMIN";
export const GET_ADDITIONAL = "GET_ADDITIONAL";
export const SET_FEEDS = "GET_FEEDS_BY_USER";
export const ADD_FEED = "ADD_FEED";
export const UPDATE_FEEDS = "UPDATE_FEEDS";
export const SEARCH = "SEARCH";
export const SET_SEARCH = "SET_SEARCH";
export const SET_PUBLISHED = "SET_PUBLISHED";
export const CLEAR_FEEDS = "CLEAR_FEEDS";
export const DELETE_FEED = "DELETE_FEED";
export const UNPUBLISHED_FEED = "UNPUBLISHED_FEED";
export const PUBLISHED_FEED = "PUBLISHED_FEED";
export const RUN_FEED = "RUN_FEED";
export const PAUSE_FEED = "PAUSE_FEED";
export const SET_FEED_STATUS = "SET_FEED_STATUS";
